import {
  DIVISIONS_LOADING,
  DIVISIONS_SUCCESS,
  DIVISIONS_ERROR,
} from '../actions/dividionAction';

const initialState = {
  divisions: [],
  loading: false,
  error: null,
};

export default function divisions(state = initialState, action = {}) {
  switch (action.type) {
    case DIVISIONS_LOADING:
      return { ...state, loading: true, error: null };
    case DIVISIONS_SUCCESS:
      return { ...state, loading: false, divisions: action.payload || [] };
    case DIVISIONS_ERROR:
      return { ...state, loading: false, error: action.error || 'Error' };
    default:
      return state;
  }
}
